import { useFirestorePhotoWish } from "~/composables/useFirebasePhotowish";
import { useEvent } from "~/composables/useEvent";
import { useAuthStore } from "@/stores/auth";
import { useUserStore } from "@/stores/user";
import { useAppStateStore } from "@/stores/appState";
import { useTemplateStore } from "@/stores/template";
import { useNotificationStore } from "@/stores/notification";
import { useWishStore } from "@/stores/wish";
import { db } from "@/services/firebase/Instance";
import _ from "lodash"
import { doc, getDoc, setDoc } from "firebase/firestore";
import eventSetProducebookSheet from "~/services/api/producebook";
import dayjs from "dayjs";
import Swal from "sweetalert2";

export const useEventStore = defineStore("event", {
  state: () => ({
    eventId: null,
    event: null,
    unsubScribe: null,
  }),
  getters: {
    getWeddingTitle(): any {
      try {

        let str = []
        if (this.event?.information?.bride?.firstName) {
          str.push(this.event?.information?.bride?.firstName)

        }
        if (this.event?.information?.groom?.firstName) {
          str.push("&")

          str.push(this.event?.information?.groom?.firstName )
        }

        return str.join(' ')
      } catch (error) {
        return null
      }
    },
    getEventType(): string {
      return  this.event?.eventType || 'wedding'
    },
    getPackage(): string {
      return this.event?.package || 'free'
    },
    isRealOwner(): boolean { // เจ้าของ Event 
      const userStore = useUserStore();

      if(userStore?.user?.invite === true) {
        return false
      }

      return  true
    },
    isOwner(): boolean { // check for invite mode

      return true
      const authStore = useAuthStore();

      if (authStore?.isDebugMode) {
        return true
      }

      if (authStore?.role === 'admin') {
        return true
      }

      if (authStore?.user?.inviteMode === 'editor') {
        return true
      }

      const isOwner = this.event?.user[authStore.line.userId] || false
      return isOwner
    },
    isEventDev() {
      const events = ['chompoo', 'demo1', 'demo2', 'demo3']
      if(_.includes(events, this.eventId)) {
        return true
      }
      return false
    }
  },
  actions: {
    async main() {
      const authStore = useAuthStore();
      const eventId = authStore.user && authStore.user.eventId;

      this.eventId = eventId;
    },
    async checkEventAlready(eventId: string) {
      const isAlreadyExits = await useEvent().checkEventAlreadyExists(eventId);
      if (!isAlreadyExits) {
        return false
      }
      return true
    },
  
    async getEventById(_eventId: string,): Promise<void> {
      return await useEvent().getEvent(_eventId);
    },
    async createEvent(_eventId: string, payload: any): Promise<void> {
      await useEvent().insertEvent(_eventId, payload);

      if (payload.userInfo) {
        await this.updateMetaConvention(_eventId, payload);
      }
    },
    async updateEvent(payload: any): Promise<void> {
      await useEvent().updateEvent(this.eventId, payload);
    },
    async setMergeEvent(payload: any): Promise<void> {
      await useEvent().setUpdate(this.eventId, payload);

      if (payload.userInfo) {
        await this.updateMetaConvention(this.eventId, payload);
      }
    },
    async setMergeEventByEventId(_eventId: string, payload: any): Promise<void> {
      await useEvent().setUpdate(this.eventId, payload);
    },
    async updateEventNotify(eventId: string, payload: any) {
      await useEvent().updateEvent(eventId, payload);
    },
    async updatePromptpayPinVerify(payload: any): Promise<void> {
      await useEvent().setUpdate(this.eventId, payload);

    },
    async getPairCodeFromEvent(pairCode: string) {
      return await useEvent().getEventByPairCode(pairCode);
    },

    async updatePairCodeIntoEvent(payload) {
      await useEvent().setUpdate(this.eventId, payload);
    },

   

    async fetchEventRealtime() {
      const templateStore = useTemplateStore();

      await new Promise<void>((resolve) => {
        const unSub = useEvent().fetchRealtimeEvent(
          this.eventId,
          (event) => {
            this.event = event;
            templateStore.setTemplateSelected(event?.templates);

            resolve(); // ได้ข้อมูลครั้งแรกแล้ว
          }
        );

        this.unsubScribe = unSub;
      });

      console.log('event โหลดครั้งแรกเสร็จแล้ว');
    },

    async saveShipping(payload: any) {
      await this.updateEvent({ shipping: payload });
    },
    async saveProduceBook(payload: any) {
      const appStateStore = useAppStateStore()
      const notificationStore = useNotificationStore()
      const userStore = useUserStore()
      const wishStore = useWishStore()


      try {
        
        await Promise.all([
          
          // save event to firebase
          this.updateEvent({ produceBook: payload }),

          // append to produce book api
          eventSetProducebookSheet().appendRow({
            eventData: {
              ...this.event,
              produceBook: payload
            },
            wishCount: wishStore.wishedList?.length || 0,
            userData: userStore.user || {}
          }),

          // send notification sms
          notificationStore.sendNotifySMSToUser([
            `Event ID : ${this.eventId} has created job for produce book at ${new Date().toISOString()}`,
          ])
        ])  
      } catch (error) {
        console.error('Error updating produceBook:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'ข้อมูลการผลิตหนังสือเคยถูกบันทึกข้อมูลไปแล้ว กรุณาติดต่อเจ้าหน้าที่เพื่อทำการแก้ไข',
        });
      } finally {
        appStateStore.isLoading = false;
      }

      

    },
   
  },
});


